import React from 'react';
import PremiumIcon from '@wix/da-ds/pkg/Icons/PremiumFolder';
import { useTranslation } from 'react-i18next';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import StatisticsBar from '../../../../DeviationViews/Helper/StatisticsBar';
import s from './TierCardForExplorer.scss';
var COVER_IMAGE_RATIO = 1.774;
var coverImagePadding = parseInt(s['padding']);
var TierCardForExplorer = function (_a) {
    var deviation = _a.deviation, width = _a.width, onClick = _a.onClick;
    var t = useTranslation().t;
    var title = deviation.title, coverImage = deviation.coverImage, tier = deviation.tier;
    if (!deviation.tier) {
        return null;
    }
    var onClickHandler = function () { return onClick(deviation); };
    var coverImageWidth = width - 2 * coverImagePadding;
    var coverImageHeight = width / COVER_IMAGE_RATIO;
    var _b = (tier || {}).stats, _c = _b === void 0 ? {} : _b, _d = _c.subscribers, numSubscribers = _d === void 0 ? undefined : _d;
    var stats = [
        numSubscribers !== undefined && {
            icon: PremiumIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers,
            }),
        },
    ].filter(function (stat) { return stat; });
    return (React.createElement("div", { className: s['root'], onClick: onClickHandler },
        React.createElement("div", { className: s['dumbo-wrapper'] }, coverImage ? (React.createElement(DeviationDumbView, { className: s['dumbo'], deviation: coverImage, width: coverImageWidth, height: coverImageHeight })) : (React.createElement("div", { className: s['placeholder-cover'], style: { width: coverImageWidth, height: coverImageHeight } }))),
        React.createElement("div", { className: s['title'] }, title),
        !!stats.length && React.createElement(StatisticsBar, { className: s['stats'], stats: stats })));
};
TierCardForExplorer.displayName = 'TierCardForExplorer';
export default TierCardForExplorer;
//# sourceMappingURL=TierCardForExplorer.js.map